import { useState, createContext, useContext } from "react";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

const ClientesBodyContext = createContext();

const ClientesBodyContextProvider = ({ children }) => {
  const { queryParams, setQueryParams } = useContext(QueryParamsContext);

  // switches
  const [deliveryAddress, setDeliveryAddress] = useState(
    queryParams.guia_clientes_enderecos === "1"
  );
  const [contacts, setContacts] = useState(
    queryParams.guia_clientes_contatos === "1"
  );
  const [authorized, setAuthorized] = useState(
    queryParams.guia_clientes_autorizados === "1"
  );
  const [commercialInfos, setCommercialInfos] = useState(
    queryParams.guia_clientes_infoscomerciais === "1"
  );
  const [financialInfos, setFinancialInfos] = useState(
    queryParams.guia_clientes_infosfinanceiras === "1"
  );
  const [othersInfos, setOthersInfos] = useState(
    queryParams.guia_clientes_outrasinfos === "1"
  );

  return (
    <ClientesBodyContext.Provider
      value={{
        // switches
        deliveryAddress,
        setDeliveryAddress,
        contacts,
        setContacts,
        authorized,
        setAuthorized,
        commercialInfos,
        setCommercialInfos,
        financialInfos,
        setFinancialInfos,
        othersInfos,
        setOthersInfos,

        queryParams,
        setQueryParams,
      }}
    >
      {children}
    </ClientesBodyContext.Provider>
  );
};

export { ClientesBodyContext, ClientesBodyContextProvider };
